// import node module libraries
import { Col, Row, Card } from 'react-bootstrap';

const Version_00_00_01 = () => {
	return (
		<Row>
			<Col lg={12} md={12} sm={12}>
				<Card>
					<Card.Body>
						<Row className="g-0">
							<Col lg={3} md={4} sm={12}>
								<div id="initial">
									<h5 className="mb-3 fwsemi--bold">
										<code>v0.0.1</code> - 30. Sep. 2024
									</h5>
								</div>
							</Col>
							<Col lg={9} md={8} sm={12}>
								<div>
									<h4 className="mb-1 fw-semi-bold">
										Initialer Start - 🚀 wir sind online!
									</h4>
									<ul>
										<li>Neue FunktionenAnmelden, Abmelden</li>
										<li>
											Added required data files for new react pages listed
											below.
										</li>
										<li>Added new media files in assets/images.</li>
									</ul>
								</div>
								<div className="mb-3">
									<h4>Basisfunktionen:</h4>
									<ul>
										<li>
											Neu - Anmeldung
										</li>
										<li>
											Neu - Abmeldung
										</li>
										<li>
											Neu - User Session
										</li>
									</ul>
								</div>
							</Col>
						</Row>
					</Card.Body>
				</Card>
			</Col>
		</Row>
	);
};

export default Version_00_00_01;
